import React from 'react';
import styled from 'styled-components';

const Title = styled.h2`
    color: #009d80;
    text-align: center;
    margin-bottom: 20px;
`;

const TrColor = styled.tr`
    color: #00ad80;
`;
const TdColor = styled.td`
    color: #00ad80;
`;
const Table = () => {
    return (
        <>
            <Title>令和7年度　公立高校入試A日程での競争倍率</Title>
            <table className="table table-border text-center">
                <thead>
                    <tr><th>学校名</th><th>競争倍率</th><th>不合格者数</th></tr>
                </thead>
                <tbody>

                    <tr>
                        <TdColor>岡豊（体育）</TdColor><TdColor>1.30倍</TdColor><td>12名</td>
                    </tr>

                    <TrColor>
                        <td>丸の内（普通）</td><td>1.26倍</td><td>36名</td>
                    </TrColor>

                    <tr>
                        <TdColor>高知農業（食ビ）</TdColor><TdColor>1.25倍</TdColor><td>10名</td>
                    </tr>

                    <tr>
                        <td>高知商業（総合ﾏﾈ）</td><td>1.24倍</td><TdColor>34名</TdColor>
                    </tr>

                    <tr>
                        <td>岡豊（普通）</td><td>1.22倍</td><TdColor>53名</TdColor>
                    </tr>

                    <tr>
                        <td>高知商業（社会ﾏﾈ）</td><td>1.19倍</td><td>13名</td>
                    </tr>

                </tbody>
            </table>

        </>
    );
}

export default Table;